import React from 'react';
// Components
import { NftCard } from '../../../../components/nft-card/NftCard';
// Styles
import './nft-cards.scss';
export var NftCards = function (_a) {
    var cards = _a.cards;
    return (React.createElement("div", { className: "multifarm-nft-view-page__nft-list" }, cards.map(function (card, index) { return (React.createElement(NftCard, { key: index, name: card.name, url: card.url, details: card.details, collectionUrl: card.collectionUrl, onClick: card.onClick })); })));
};
